





















































/**
 * 海报生成方式： 客户端生成
 *
 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import request from "@/api/index";
import native from "@/common/Native";
import { Toast } from "vant";
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import { dateFormat } from "@/common/Utils";
@Component
export default class Poster extends Vue {
  @Prop({ default: "" })
  infoClassifyId!: string;
  @Prop({ default: "看万州客户端" })
  appName!: string;
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  public request: any = new request();
  // 海报
  id: string = "";
  private showPoster: boolean = false;
  private showLoading: boolean = false;
  private posterImg: string = "";
  private posterImgBg: string = "";
  private qrcodeSrc: string = "";
  private posterTopImg: string = "";
  private posterCreateTime: string = "";
  private posterTitle: string = "";
  private posterDetail: {
    posterShare: string | number;
    posterImg: string;
  } = {
    posterShare: "",
    posterImg: ""
  };

  private isOpenInApp: boolean = false;

  mounted() {}

  @Watch("infoClassifyId")
  onInfoClassifyIdChanged(value: string) {
    if (value) {
      this.initialPoster();
    }
  }
  initialPoster() {
    // 海报
    // 屏蔽海报
    let isPosterUsefull = true,
      _this = this;
    this.id = this.$route.query.id as string;
    this.isOpenInApp = native.isOpenInApp();

    if (this.isOpenInApp && isPosterUsefull) {
      this.getPosterData().then(() => {
        (window as any).posterShare = this.posterDetail.posterShare;

        this.posterTopImg = this.posterDetail.posterImg;
        this.posterImgBg = this.posterDetail.posterImg;

        native.getUserInfo().then((response: any) => {
          this.userInfo = response;
          console.log(this.userInfo);
          if (this.posterDetail.posterShare) {
            let str = window.location.href;
            QRCode.toDataURL(str)
              .then((url: string) => {
                this.qrcodeSrc = url;

                this.$nextTick(() => {
                  (window as any).generateImg = this.generateImg;
                  //暴露关闭海报
                  (window as any).doDismissPoster = () => {
                    _this.showPoster = false;
                  };
                });
              })
              .catch((err: any) => {
                console.error(err);
              });
          }
        });
      });
    }
  }
  getPosterData() {
    return this.request
      .getPosterShareData({
        infoClassifyId: this.infoClassifyId
      })
      .then((res: any) => {
        if (res.code >= 0) {
          this.posterDetail = res.data;
        }
      });
  }
  savePoster() {
    native.savePoster(this.posterImg).then(() => {
      this.showPoster = false;
    });
  }

  sharePoster() {
    native.sharePoster(this.posterImg).then(() => {
      this.showPoster = false;
    });
  }
  generateImg() {
    this.showPoster = true;

    // 海报生成时间
    this.posterCreateTime = dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss");

    if (!this.posterImg) {
      (document.querySelector("#posterOperate") as HTMLElement).style.display =
        "none";
      (document.querySelector(
        "#posterContent"
      ) as HTMLElement).style.paddingBottom = "0.5rem";
    }

    setTimeout(() => {
      let clientWidth = document.body.clientWidth;
      const poster = this.$refs.poster as HTMLElement;
      console.log(poster);
      console.log(poster.offsetWidth);
      const img = this.$refs.posterImg as HTMLImageElement;
      const scale = clientWidth / poster.offsetWidth;
      const toImg = () => {
        // 不重复绘制
        if (!this.posterImg) {
          Toast.loading({
            message: "海报生成中...",
            forbidClick: true
          });
          html2canvas(poster, {
            useCORS: true
          }).then(async canvas => {
            try {
              this.posterImg = canvas.toDataURL("image/png");
            } catch (err) {
              console.log("err");
              console.log(err);
            }
            Toast.clear();

            (document.querySelector(
              "#posterOperate"
            ) as HTMLElement).style.display = "flex";
            (document.querySelector(
              "#posterContent"
            ) as HTMLElement).style.paddingBottom = "1.5rem";
          });
        }
      };
      if (img.complete) {
        toImg();
      } else {
        img.onload = () => {
          toImg();
        };
      }
    }, 500);
  }
}
